import axios from "axios";

const apiInt = process.env.REACT_APP_API_BASE_URL;

async function uploadFile(
  file: File,
  bucketName: string,
  key: string,
  isSetBucketNameWithUrl?: string
): Promise<string | undefined> {
  try {
    const filePath = `bucketname=${bucketName}&key=${key}&ispublicread=true`;
    const presignUrl = await GeneratePresignUrl(filePath);
    console.log("🚀 ~ file: uploadFile.ts:11 ~ presignUrl:", presignUrl);

    const headers = {
      "Content-Type": "image/*"
    };

    await fetch(presignUrl, {
      method: "PUT",
      mode: "cors",
      cache: "no-cache",
      referrerPolicy: "origin-when-cross-origin",
      body: file,
      headers: headers
    })
      .then(() => {})
      .then((res) => {
        console.log("File uploaded successfully!", res);
      })
      .catch((error) => {
        console.log("file: " + file + ", filePath:" + filePath);
        console.log("Error:", error);
      });

    // return presignUrl.split("?")[0];
    return `https://${isSetBucketNameWithUrl}/${key}`;
  } catch (error) {
    console.error("Error:", error);
    return undefined;
  }
}

async function GeneratePresignUrl(filePath: string): Promise<string> {
  console.log(
    "🚀 ~ file: uploadFile.ts:42 ~ GeneratePresignUrl ~ filePath:",
    filePath
  );
  const s3PresignUrlApiEndpoint = `/loyaltyprogram/s3presignurl?${filePath}`;
  const apiUrl = apiInt + s3PresignUrlApiEndpoint;
  const response = await axios.get(apiUrl, {});
  console.log(
    "🚀 ~ file: uploadFile.ts:33 ~ GeneratePresignUrl ~ response:",
    response?.data
  );
  return response.data;
}

export default uploadFile;
